import React from "react"
import { ContactBanner } from "./contact-banner"

export const ContactSection = ({ contactInfo, socialMediaLinks }: { contactInfo: any, socialMediaLinks: any }) => {
  return (
    <ContactBanner contactInfo={contactInfo} socialMediaLinks={socialMediaLinks} />
  )
}
